import moment from 'moment';

/**
 * @param {String} maturity_iso maturity date
 * @param {String} target_date target date
 * @return {Number} Time
 */
export function getTimeToMaturityInYears(maturity_iso, target_date = new Date()) {
  maturity_iso = moment(maturity_iso).format('YYYY-MM-DD');

  const maturityDate = new Date(Date.parse(maturity_iso + 'T16:00-05:00'));
  const targetDate = new Date(target_date);

  let time = maturityDate.getTime() - targetDate.getTime();

  time = (time + Number.EPSILON) / (1000 * 60 * 60 * 24 * 365.25);

  return time;
}
